// extracted by mini-css-extract-plugin
export default {"SectionHeader":"SectionHeader-module-f1585b47ffe96b3cb949","iconRight":"SectionHeader-module-da2bceb3e9d64b27d174"};